// Zero-dependency Airtable health check — first ping is deferred, then polled periodically
// Separate module so it doesn't wait for Airtable SDK, Sentry, etc. to load
const baseId = import.meta.env.VITE_AIRTABLE_OPERATIONS_BASE_ID;
const token = import.meta.env.VITE_AIRTABLE_ACCESS_TOKEN;

const TIMEOUT_MS = 5000;
const INITIAL_DELAY_MS = 2000; // let the page settle before first ping
const POLL_INTERVAL_MS = 30000;
const FAILURES_BEFORE_OUTAGE = 2; // require consecutive failures

const url = baseId && token
  ? `https://api.airtable.com/v0/${baseId}/${encodeURIComponent('Scheduled Offerings')}?maxRecords=1&fields%5B%5D=SO`
  : null;

function ping() {
  if (!url) return Promise.resolve(true);
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  return fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
    signal: controller.signal,
  })
    .then((res) => {
      clearTimeout(timer);
      // 4xx errors (auth, rate-limit, validation) are not outages — only 5xx or network failures
      return res.status < 500;
    })
    .catch(() => { clearTimeout(timer); return false; });
}

// External store for useSyncExternalStore
let isOutage = false;
let consecutiveFailures = 0;
const listeners = new Set();

function setOutage(outage) {
  if (outage === isOutage) return;
  isOutage = outage;
  listeners.forEach((fn) => fn());
}

function handlePingResult(ok) {
  if (ok) {
    consecutiveFailures = 0;
    setOutage(false);
  } else {
    consecutiveFailures++;
    if (consecutiveFailures >= FAILURES_BEFORE_OUTAGE) {
      setOutage(true);
    }
  }
}

// Delay first check so it doesn't compete with initial page load resources
if (url) {
  setTimeout(() => {
    ping().then(handlePingResult);
    setInterval(() => { ping().then(handlePingResult); }, POLL_INTERVAL_MS);
  }, INITIAL_DELAY_MS);
}

export function subscribeHealth(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function getHealthSnapshot() {
  return isOutage;
}
